/*
  bundle-builder.js — Build Your Bundle drawer.

  Staged-tray model: picking stages items locally (instant, no network); a single
  "Add bundle to cart" commits them all via /cart/add, then the theme's own cart
  drawer + free-shipping bar update through the native ajaxProduct:added event. No
  second cart, no divergence.

  Progress is CART-AWARE: seeded from /cart.js on open, plus the staged bundle on top,
  because free shipping is judged on the whole order (and a head-start makes the goal
  feel closer). NO discount — the incentive is free delivery over the market threshold.
*/
(function () {
  'use strict';

  /* Customer-facing size labels — mirrors snippets/size-label.liquid.
     DISPLAY ONLY: every comparison (card.__size, data-bb-size, variant option matching)
     still uses the RAW value, so variants, inventory and cart payloads are unaffected.
     Unlisted values (sock sizes, UNI) pass through unchanged. */
  var SIZE_LABELS = { '1-2': 'S-M', '3-4': 'L-XL', '5-6': '2XL-3XL', '2-S': 'S', '3-M': 'M', '4-L': 'L', '5-XL': 'XL' };
  function sizeLabel(v) { return (v && SIZE_LABELS[v]) || v; }

  var drawer = document.querySelector('[data-bb-drawer]');
  if (!drawer || drawer.__bbInit) { return; }
  drawer.__bbInit = true;
  var BB = (function(){ var d={sold_out:'Sold out',add_to_bundle:'Add to bundle',tray_empty:'Your bundle is empty — pick your first pair above.',remove_one:'Remove one',add_one:'Add one',remove:'Remove',commit:'Add bundle to cart',commit_one:'Add @@N@@ pair',commit_other:'Add @@N@@ pairs',unlocked_html:'✓ <strong>Free delivery unlocked</strong> — nice bundle.',goal_start_html:'Add <strong>@@AMT@@</strong> of tights for <strong>FREE delivery</strong>',goal_more_html:'<strong>@@AMT@@</strong> more for <strong>FREE delivery</strong>',style_one:'style',styles:'styles',adding:'Adding…',added:'Added ✓'};
    try{ var _n=document.querySelector('[data-bb-i18n]'); if(_n){ var _p=JSON.parse(_n.textContent); if(_p){ for(var _k in _p){ if(_p[_k])d[_k]=_p[_k]; } } } }catch(e){} return d; })();

  /* LAZY INIT. At page load this script does NOTHING to the DOM — it only binds the
     open trigger. All heavy work (relocating the drawer to <body>, parsing 27 variant
     blobs, painting cards) runs in boot(), on the first open. This keeps the bundle
     entirely off the product page's critical path so it cannot reflow-thrash the
     gallery's Flickity slider while it measures itself during init. */

  var THRESHOLD = parseInt(drawer.getAttribute('data-threshold'), 10) || 0;
  var FEATURED = drawer.getAttribute('data-featured') || '';

  var panel = drawer.querySelector('.bbd__panel');
  var grid = drawer.querySelector('[data-bb-grid]');
  var noneEl = drawer.querySelector('[data-bb-none]');
  var countEl = drawer.querySelector('[data-bb-count]');
  var fill = drawer.querySelector('[data-bb-fill]');
  var track = drawer.querySelector('[data-bb-track]');
  var goalMsg = drawer.querySelector('[data-bb-goalmsg]');
  var trayList = drawer.querySelector('[data-bb-tray]');
  var trayToggle = drawer.querySelector('[data-bb-tray-toggle]');
  var trayCount = drawer.querySelector('[data-bb-tray-count]');
  var subtotalEl = drawer.querySelector('[data-bb-subtotal]');
  var commitBtn = drawer.querySelector('[data-bb-commit]');
  var commitLabel = drawer.querySelector('[data-bb-commit-label]');

  var cards = [].slice.call(grid.querySelectorAll('[data-bb-card]'));
  var tray = [];          // [{id, qty, handle, title, variant, price, img}]
  var cartBaseline = 0;   // cents already in the live cart
  var activeSize = null;
  var lastFocus = null;

  function money(cents) {
    if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return '€' + (cents / 100).toFixed(2);
  }

  /* ---------- card model (built lazily by boot) ---------- */
  function buildCards() {
    cards.forEach(function (card) {
      var variants;
      try { variants = JSON.parse(card.getAttribute('data-variants')); }
      catch (e) { variants = []; }
      card.__v = variants;
      card.__sizePos = parseInt(card.getAttribute('data-size-pos'), 10) || 0;
      card.__colorPos = parseInt(card.getAttribute('data-color-pos'), 10) || 0;
      card.__uni = card.getAttribute('data-bb-uni') === 'true';
      card.__size = null;
      card.__gi = 0; // gallery index
      var sw = card.querySelector('.bbc__swatch.is-active');
      card.__color = sw ? sw.getAttribute('data-bb-color') : null;
      /* Single-size (incl. UNI / One-size) products need no size tap: auto-select the
         only value so Add resolves immediately and no size row is shown. */
      if (card.__sizePos) {
        var ss = card.__v.map(function (v) { return v.o[card.__sizePos - 1]; })
                         .filter(function (s, i, a) { return s && a.indexOf(s) === i; });
        if (ss.length === 1) { card.__size = ss[0]; }
      }
    });
  }

  /* Float the product you opened from to the front. */
  function floatFeatured() {
    if (!FEATURED) { return; }
    var feat = cards.filter(function (c) { return c.getAttribute('data-handle') === FEATURED; })[0];
    if (feat && feat.parentNode === grid) { grid.insertBefore(feat, grid.firstChild); }
  }

  /* ---------- per-card image gallery (transform track — no scrolling) ---------- */
  function galleryImgs(card) { return card.querySelectorAll('.bbc__img'); }

  function setGallery(card, i) {
    var n = galleryImgs(card).length;
    if (n < 2) { return; }
    i = ((i % n) + n) % n;               // wrap both ways
    card.__gi = i;
    var track = card.querySelector('[data-bb-gallery]');
    if (track) { track.style.transform = 'translateX(' + (-i * 100) + '%)'; }
    [].forEach.call(card.querySelectorAll('[data-bb-dot]'), function (d, di) {
      d.classList.toggle('is-active', di === i);
    });
  }
  function galleryStep(card, dir) { setGallery(card, (card.__gi || 0) + dir); }

  /* Show the image tied to a variant (used on colour change), then let arrows/dots
     navigate the rest. Falls back to leaving the current image if no match. */
  function galleryShowVariantImage(card, v) {
    if (!v || !v.img) { return; }
    var imgs = galleryImgs(card);
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].src === v.img || imgs[i].getAttribute('data-src-key') === v.img) { setGallery(card, i); return; }
    }
  }

  function resolve(card) {
    if (card.__sizePos && !card.__size) { return null; }
    return card.__v.filter(function (v) {
      if (card.__colorPos && card.__color && v.o[card.__colorPos - 1] !== card.__color) { return false; }
      if (card.__sizePos && card.__size && v.o[card.__sizePos - 1] !== card.__size) { return false; }
      return true;
    })[0] || null;
  }

  /* Quantity of ONE exact variant (colour+size) — drives the card stepper, so switching
     colour or size shows that variant's own count, never the product total. */
  function qtyForVariant(id) {
    var t = tray.filter(function (x) { return x.id === id; })[0];
    return t ? t.qty : 0;
  }

  function qtyInTrayForCard(card) {
    var ids = card.__v.map(function (v) { return v.id; });
    return tray.filter(function (t) { return ids.indexOf(t.id) !== -1; })
               .reduce(function (n, t) { return n + t.qty; }, 0);
  }

  function paintCard(card) {
    var v = resolve(card);
    var priceNow = card.querySelector('[data-bb-price-now]');
    var colorLabel = card.querySelector('[data-bb-color-label]');
    var badge = card.querySelector('[data-bb-badge]');
    var badgeN = card.querySelector('[data-bb-badge-n]');
    var add = card.querySelector('[data-bb-add]');
    var addLabel = card.querySelector('[data-bb-add-label]');
    var inTray = qtyInTrayForCard(card);

    if (v && priceNow) { priceNow.textContent = money(v.p); }
    if (colorLabel && card.__color) { colorLabel.textContent = card.__color; }
    if (badge) { badge.hidden = inTray === 0; }
    if (badgeN) { badgeN.textContent = String(inTray); }

    [].forEach.call(card.querySelectorAll('[data-bb-size]'), function (b) {
      var val = b.getAttribute('data-bb-size');
      var ok = card.__v.some(function (vv) {
        if (card.__colorPos && card.__color && vv.o[card.__colorPos - 1] !== card.__color) { return false; }
        return vv.o[card.__sizePos - 1] === val && vv.a;
      });
      b.disabled = !ok;
      var on = card.__size === val;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var stepper = card.querySelector('[data-bb-stepper]');
    var qtyThis = v ? qtyForVariant(v.id) : 0;

    var noStock = card.__v.every(function (vv) { return !vv.a; });
    var pickedSoldOut = card.__size && v && !v.a;
    if (!add) { return; }
    if (noStock || pickedSoldOut) {
      /* No "Notify me" — just a quiet, disabled Sold-out state. */
      if (stepper) { stepper.hidden = true; }
      add.hidden = false;
      add.disabled = true;
      add.classList.remove('is-added');
      if (addLabel) { addLabel.textContent = BB.sold_out; }
      return;
    }
    if (qtyThis > 0 && stepper) {
      /* In the bundle → stepper replaces the button, in the same slot. */
      add.hidden = true;
      stepper.hidden = false;
      var nEl = stepper.querySelector('[data-bb-stepn]');
      if (nEl) { nEl.textContent = String(qtyThis); }
    } else {
      if (stepper) { stepper.hidden = true; }
      add.hidden = false;
      add.disabled = false;
      add.classList.remove('is-added');
      if (addLabel) { addLabel.textContent = BB.add_to_bundle; }
    }
  }

  /* ---------- tray ---------- */
  function bundleSubtotal() {
    return tray.reduce(function (n, t) { return n + t.price * t.qty; }, 0);
  }
  function bundleCount() {
    return tray.reduce(function (n, t) { return n + t.qty; }, 0);
  }

  function addVariant(card, v) {
    var existing = tray.filter(function (t) { return t.id === v.id; })[0];
    if (existing) { existing.qty += 1; }
    else {
      var variantLabel = [];
      if (card.__colorPos && v.o[card.__colorPos - 1]) { variantLabel.push(v.o[card.__colorPos - 1]); }
      if (card.__sizePos && v.o[card.__sizePos - 1]) { variantLabel.push(sizeLabel(v.o[card.__sizePos - 1])); }
      tray.push({
        id: v.id, qty: 1, handle: card.getAttribute('data-handle'),
        title: card.getAttribute('data-title'), variant: variantLabel.join(' · '),
        price: v.p, img: v.img || (card.querySelector('.bbc__img') || {}).src
      });
    }
    renderAll();
  }

  function changeTrayQty(id, delta) {
    var item = tray.filter(function (t) { return t.id === id; })[0];
    if (!item) { return; }
    item.qty += delta;
    if (item.qty <= 0) { tray = tray.filter(function (t) { return t.id !== id; }); }
    renderAll();
  }
  function removeTray(id) { tray = tray.filter(function (t) { return t.id !== id; }); renderAll(); }

  function renderTray() {
    if (!tray.length) {
      trayList.innerHTML = '<p class="bbd__empty" data-bb-empty>'+BB.tray_empty+'</p>';
    } else {
      trayList.innerHTML = tray.map(function (t) {
        return '<div class="bbd__item" data-bb-item="' + t.id + '">' +
          '<img class="bbd__itemimg" src="' + (t.img || '') + '" alt="" loading="lazy">' +
          '<div class="bbd__iteminfo"><p class="bbd__itemname">' + esc(t.title) + '</p>' +
          '<p class="bbd__itemvar">' + esc(t.variant) + '</p></div>' +
          '<div class="bbd__itemright"><span class="bbd__itemprice">' + money(t.price * t.qty) + '</span>' +
          '<span class="bbd__stepper"><button type="button" class="bbd__stepbtn" data-bb-tdec="' + t.id + '" aria-label="'+BB.remove_one+'">−</button>' +
          '<span class="bbd__stepqty">' + t.qty + '</span>' +
          '<button type="button" class="bbd__stepbtn" data-bb-tinc="' + t.id + '" aria-label="'+BB.add_one+'">+</button></span>' +
          '<button type="button" class="bbd__remove" data-bb-trm="' + t.id + '">'+BB.remove+'</button></div></div>';
      }).join('');
    }
    if (trayCount) { trayCount.textContent = String(bundleCount()); }
    if (subtotalEl) { subtotalEl.textContent = money(bundleSubtotal()); }
  }

  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) {
    return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- progress ---------- */
  function renderProgress() {
    var count = bundleCount();
    var projected = cartBaseline + bundleSubtotal();

    if (commitBtn) {
      commitBtn.disabled = count === 0;
      if (commitLabel) {
        commitLabel.textContent = count === 0 ? BB.commit
          : (count === 1 ? BB.commit_one : BB.commit_other).replace('@@N@@', count) + ' · ' + money(bundleSubtotal());
      }
    }

    if (!THRESHOLD || !fill) { return; }
    var remaining = THRESHOLD - projected;
    var pct = Math.max(0, Math.min(100, Math.round((projected * 100) / THRESHOLD)));
    fill.style.width = pct + '%';
    if (track) { track.setAttribute('aria-valuenow', projected); }

    if (remaining <= 0) {
      drawer.setAttribute('data-bb-unlocked', 'true');
      if (goalMsg) { goalMsg.innerHTML = BB.unlocked_html; }
    } else {
      drawer.removeAttribute('data-bb-unlocked');
      if (goalMsg) {
        goalMsg.innerHTML = count === 0
          ? BB.goal_start_html.replace('@@AMT@@', money(remaining))
          : BB.goal_more_html.replace('@@AMT@@', money(remaining));
      }
    }
  }

  /* ---------- filtering ----------
     No size selected  -> show everything.
     Size selected     -> show only products with an AVAILABLE variant in that size,
                          PLUS one-size (UNI) products, which have no size to match and
                          stay available under every filter. Non-matches are hidden
                          outright (no dimmed "out of size" shelf). */
  function applyFilters() {
    var shown = 0;
    cards.forEach(function (card) {
      var visible;
      if (!activeSize) {
        visible = true;
      } else if (card.__uni) {
        visible = true;
      } else {
        visible = card.__sizePos > 0 && card.__v.some(function (v) {
          return v.o[card.__sizePos - 1] === activeSize && v.a;
        });
        if (visible) { card.__size = activeSize; } // prefill the chosen size
      }
      card.hidden = !visible;
      if (visible) { shown++; paintCard(card); }
    });
    if (noneEl) { noneEl.hidden = shown !== 0; }
    if (countEl) { countEl.textContent = shown + ' ' + (shown === 1 ? BB.style_one : BB.styles) + (activeSize ? ' in ' + activeSize : ''); }
  }

  function renderAll() { cards.forEach(paintCard); renderTray(); renderProgress(); }

  /* ---------- commit ---------- */
  function commit() {
    if (!tray.length) { return; }
    var items = tray.map(function (t) { return { id: t.id, quantity: t.qty }; });
    var url = (window.routes && routes.cartAdd) || '/cart/add';
    if (url.slice(-3) !== '.js') { url += '.js'; }
    commitBtn.disabled = true;
    if (commitLabel) { commitLabel.textContent = BB.adding; }
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (commitLabel) { commitLabel.textContent = BB.added; }
        commitBtn.classList.add('is-success');
        tray = [];
        cards.forEach(paintCard);
        renderTray();
        /* Close our drawer first, THEN hand off: ajaxProduct:added rebuilds AND opens
           the theme's own cart drawer (theme.js), which carries the free-shipping bar.
           Closing first avoids the two-drawers z-index collision. */
        setTimeout(function () {
          close();
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: res }, bubbles: true }));
          resetFooter();
        }, 620);
      })
      .catch(function () { commitBtn.disabled = false; commitBtn.classList.remove('is-success'); renderProgress(); });
  }

  function resetFooter() {
    if (commitLabel) { commitLabel.textContent = BB.commit; }
    commitBtn.classList.remove('is-success');
    cartBaseline = 0;
    fetchCart();
    renderProgress();
  }

  /* ---------- cart baseline ---------- */
  function fetchCart() {
    return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartBaseline = c.total_price || 0; renderProgress(); })
      .catch(function () {});
  }

  /* ---------- lazy boot (first open only) ---------- */
  var booted = false;
  function boot() {
    if (booted) { return; }
    booted = true;
    /* Relocate to <body> so position:fixed is viewport-relative, not trapped by a
       transformed ancestor. Done now (on open), not at page load, so it can't reflow
       the product gallery during its init. */
    if (drawer.parentNode !== document.body) { document.body.appendChild(drawer); }
    buildCards();
    floatFeatured();
    applyFilters();
    renderAll();
  }

  /* ---------- open / close ---------- */
  function open() {
    boot();
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    fetchCart();
    var x = drawer.querySelector('[data-bb-close]');
    if (x) { x.focus(); }
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) { lastFocus.focus(); }
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-bb-open]')) { e.preventDefault(); open(); }
  });

  drawer.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-bb-close]')) { close(); return; }

    var chip = t.closest('[data-bb-sizechip]');
    if (chip) {
      var val = chip.getAttribute('data-bb-sizechip');
      var same = activeSize === val;
      activeSize = same ? null : val;
      [].forEach.call(drawer.querySelectorAll('[data-bb-sizechip]'), function (c) {
        var on = !same && c.getAttribute('data-bb-sizechip') === val;
        c.classList.toggle('is-active', on); c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      applyFilters(); return;
    }

    if (t.closest('[data-bb-tray-toggle]')) {
      var expanded = trayToggle.getAttribute('aria-expanded') === 'true';
      trayToggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      trayList.hidden = expanded;
      return;
    }

    var tdec = t.closest('[data-bb-tdec]'); if (tdec) { changeTrayQty(parseInt(tdec.getAttribute('data-bb-tdec'), 10), -1); return; }
    var tinc = t.closest('[data-bb-tinc]'); if (tinc) { changeTrayQty(parseInt(tinc.getAttribute('data-bb-tinc'), 10), 1); return; }
    var trm = t.closest('[data-bb-trm]'); if (trm) { removeTray(parseInt(trm.getAttribute('data-bb-trm'), 10)); return; }
    if (t.closest('[data-bb-commit]')) { commit(); return; }

    var card = t.closest('[data-bb-card]');
    if (!card) { return; }

    /* gallery arrows / dots — transform only, so nothing scrolls or jumps */
    if (t.closest('[data-bb-prev]')) { e.preventDefault(); galleryStep(card, -1); return; }
    if (t.closest('[data-bb-next]')) { e.preventDefault(); galleryStep(card, 1); return; }
    var dot = t.closest('[data-bb-dot]');
    if (dot) { e.preventDefault(); setGallery(card, parseInt(dot.getAttribute('data-bb-dot'), 10)); return; }

    var sw = t.closest('[data-bb-color]');
    if (sw) {
      card.__color = sw.getAttribute('data-bb-color');
      [].forEach.call(card.querySelectorAll('[data-bb-color]'), function (b) {
        var on = b === sw; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      galleryShowVariantImage(card, resolve(card)); // show this colour's image first
      paintCard(card); return;
    }
    var sz = t.closest('[data-bb-size]');
    if (sz && !sz.disabled) { card.__size = sz.getAttribute('data-bb-size'); paintCard(card); return; }
    /* Card stepper. changeTrayQty already removes the line at 0 and calls renderAll(), which
       repaints this card back to "Add to bundle" and refreshes subtotal, progress and tray.
       card.__size / card.__color are untouched, so the chosen size+colour survive. */
    if (t.closest('[data-bb-dec]')) {
      var dv = resolve(card);
      if (dv) { changeTrayQty(dv.id, -1); }
      return;
    }
    if (t.closest('[data-bb-inc]')) {
      var iv = resolve(card);
      if (iv) { changeTrayQty(iv.id, 1); }
      return;
    }
    if (t.closest('[data-bb-add]')) {
      var rv = resolve(card);
      if (!rv) {
        /* size required but not chosen — nudge the size row, don't add */
        var sizes = card.querySelector('.bbc__sizes');
        if (sizes) { sizes.style.outline = '2px solid #8C4A57'; setTimeout(function () { sizes.style.outline = ''; }, 1200); }
        return;
      }
      /* Add quietly: update the card badge + count/progress only. Never auto-open the
         tray or throw up a "product added" view. */
      addVariant(card, rv);
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) { close(); }
  });

  /* ---------- touch swipe on card galleries (delegated) ----------
     Horizontal swipe steps the gallery; vertical is left to the browser so the page
     scrolls normally (touch-action:pan-y on the track). We only preventDefault once a
     gesture is clearly horizontal, so downward scrolling is never trapped. */
  var swView = null, swX = 0, swY = 0, swLock = 0; // swLock: 0 undecided, 1 horizontal, 2 vertical
  drawer.addEventListener('touchstart', function (e) {
    var view = e.target.closest ? e.target.closest('[data-bb-view]') : null;
    if (!view) { swView = null; return; }
    swView = view; swX = e.touches[0].clientX; swY = e.touches[0].clientY; swLock = 0;
  }, { passive: true });
  drawer.addEventListener('touchmove', function (e) {
    if (!swView) { return; }
    var dx = e.touches[0].clientX - swX, dy = e.touches[0].clientY - swY;
    if (swLock === 0 && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
      swLock = Math.abs(dx) > Math.abs(dy) ? 1 : 2;
    }
    if (swLock === 1) { e.preventDefault(); } // horizontal: we own it, block page from moving
  }, { passive: false });
  drawer.addEventListener('touchend', function (e) {
    if (!swView || swLock !== 1) { swView = null; return; }
    var dx = e.changedTouches[0].clientX - swX;
    if (Math.abs(dx) > 40) { galleryStep(swView.closest('.bbc'), dx < 0 ? 1 : -1); }
    swView = null;
  });

  /* No work at load — the drawer boots on first open (see boot/open). */
})();
